import { useState } from 'react';
import { CubeIcon } from '@heroicons/react/24/outline';

export function ProductImage({ src, alt, size = 'h-10 w-10', iconSize = 'h-5 w-5' }: { src: string | null; alt: string; size?: string; iconSize?: string }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className={`flex ${size} items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-700`}>
        <CubeIcon className={`${iconSize} text-gray-400`} />
      </div>
    );
  }
  return <img src={src} alt={alt} referrerPolicy="no-referrer" onError={() => setFailed(true)} className={`${size} rounded-lg object-cover`} />;
}
